import { Pipe, PipeTransform } from '@angular/core';
import { isNil } from 'lodash-es';
/*
 * Returns initials of an object with a firstName
 * and lastName.
 *  *
 * Usage:
 *   user = {"firstName": "foo", "lastName": "bar"}
 * Example:
 *   {{ user | initials }}
 *   formats to: 1024
*/
@Pipe({name: 'age'})
export class AgePipe implements PipeTransform {
  transform(value: any): string {
    if (isNil(value)) {
      return '';
    }

    const today = new Date();
    const birthDate = new Date(value);

    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    // sanity check
    if (age > 130 || age < 0) {
      return '';
    }

    if (age.toString() === 'NaN') {
      return '';
    }

    return age.toString();
  }
}
